import React, { useState } from 'react';
import { Tusers } from '../../../type/users';
import { ReactHiererchyChart } from '../react-hierarchy-chart';
import CardOrg from './CardOrg';
import CardOrgTwo from './CardOrgTwo';


interface LayoutChartHorizontalTwoProps {
    users: Tusers;
}
const LayoutChartHorizontalTwo = (props: LayoutChartHorizontalTwoProps) => {
    const { users } = props;
    const [isUserCollapsed, setIsUserCollapsed] = useState<boolean>(false);
    const [cardUser, setCardUser] = useState(users);


    return (
        <>
            <div className="p-[1rem]">
                <ReactHiererchyChart
                    nodes={[{ ...users, isCollapsed: isUserCollapsed }]}
                    direction="horizontal"
                    randerNode={(node: any) => {
                        return (
                            <CardOrgTwo
                                node={node}
                                edit={users.id === node.id ? false : true}

                            />
                        );
                    }}
                />
            </div>
        </>
    );

};



export default LayoutChartHorizontalTwo;